module.exports = __webpack_public_path__ + "static/media/Zweilous_gaussian2.1d0fd499.png";